<script>
import VDialogConfirm from "@/components/commonComponents/VDialogConfirm.vue";
import CommonRules from "@/mixins/CommonRules";

export default {
    name: "BpApproveDecline",
    components: {
        VDialogConfirm,
    },
    mixins: [
        CommonRules,
    ],
    props: {
        isCanAction: {
            type: Boolean
        },
        permissions: {
            type: Object,
        },
        approveQuestion: {
            type: String,
            required: true,
        },
        approveSuccess: {
            type: String,
            default: 'Успешно отправлено на утверждение',
        },
        approveAsModeratorQuestion: {
            type: String,
            required: true,
        },
        approveAsModeratorSuccess: {
            type: String,
            default: 'Успешно одобрено',
        },
        declineQuestion: {
            type: String,
            required: true,
        },
        declineSuccess: {
            type: String,
            default: 'Успешно отклонено',
        },
    },
    data() {
        return {
            isSubmit: false,
        };
    },
    computed: {
        isCanApproveAsEditor() {
            return this.isCanAction && this.permissions?.canApproveAsEditor;
        },
        isCanApproveAsApprover() {
            return this.isCanAction && this.permissions?.canApproveAsApprover;
        },
        isCanApproveAsModerator() {
            return this.isCanAction && this.permissions?.canApproveAsModerator;
        },
    },
    methods: {
        doShowConfirmApproveDecline(action, text, callbackNotifyFn) {
            this.isSubmit = true;
            const isDescriptionRequired = (action === 'decline'),
                permissions = this.permissions,
                role = (permissions.canApproveAsEditor && 'editor')
                    || (permissions.canApproveAsApprover && 'approver')
                    || (permissions.canApproveAsModerator && 'moderator');
            return this.$refs.confirm.show({
                action: action,
                role: role,
                text: text,
                form: {description: ''},
                fields: {
                    description: {
                        class: isDescriptionRequired ? 'required' : '',
                        rules: isDescriptionRequired ? [this.rules.requiredTrim] : [],
                    },
                },
            })
                .then((result) => {
                    if (result) {
                        if (callbackNotifyFn) {
                            callbackNotifyFn();
                        }
                        this.$emit('success', result);
                    }
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSubmit = false;
                });
        },
        onClickApprove() {
            this.doShowConfirmApproveDecline(
                'approve',
                this.approveQuestion,
                () => this.notifySuccess(this.approveSuccess)
            );
        },
        onClickApproveAsModerator() {
            this.doShowConfirmApproveDecline(
                'approve',
                this.approveAsModeratorQuestion,
                () => this.notifySuccess(this.approveAsModeratorSuccess)
            );
        },
        onClickDecline() {
            this.doShowConfirmApproveDecline(
                'decline',
                this.declineQuestion,
                () => this.notifySuccess(this.declineSuccess)
            );
        },
    },
}
</script>

<template>
    <v-card-actions class="pa-0">

        <slot name="prepend"></slot>

        <v-btn
            v-if="isCanApproveAsEditor"
            :disabled="isSubmit"
            @click="onClickApprove"
        >
            Предложить к публикации
        </v-btn>

        <v-btn
            v-if="isCanApproveAsApprover"
            :disabled="isSubmit"
            @click="onClickApprove"
        >
            Отправить на утверждение
        </v-btn>

        <v-btn
            v-if="isCanApproveAsModerator"
            :disabled="isSubmit"
            @click="onClickApproveAsModerator"
        >
            Одобрить
        </v-btn>

        <v-btn
            v-if="isCanApproveAsApprover || isCanApproveAsModerator"
            :disabled="isSubmit"
            @click="onClickDecline"
        >
            Отклонить
        </v-btn>

        <slot name="append"></slot>

        <v-dialog-confirm
            ref="confirm"
            type="confirm"
            @confirm="$listeners.confirm"
            v-slot="{data}"
        >
            <v-container class="pa-0">
                <v-row no-gutters>
                    <v-col>
                        {{ data.text }}
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col>
                        <v-textarea
                            v-model="data.form.description"
                            v-bind="data.fields.description"
                            label="Комментарий"
                            autofocus
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-container>
        </v-dialog-confirm>
    </v-card-actions>
</template>

<style scoped lang="scss">

</style>